import type {ReactNode} from 'react';
import {Helmet} from 'react-helmet';

import classnames from 'classnames';

import {FooterImage} from './signup/footer-image';

import styles from './pre-auth-illustrated-layout.module.css';

interface Props {
    children: ReactNode;
    illustration: ReactNode;
    showDesktopIllustrationFooter?: boolean;
    /** Show custom background for the right pane */
    rightPaneBackground?: ReactNode;
    centerIllustration?: boolean;
}

export function PreAuthIllustratedLayout(props: Props) {
    const showDesktopIllustrationFooter = props.showDesktopIllustrationFooter ?? true;

    return (
        <div className={styles['outer-container']}>
            <div className={styles['inner-container']}>
                <Helmet>
                    <meta name='viewport' content='width=device-width,initial-scale=1' />
                </Helmet>
                <div className={styles['left-content']}>
                    {props.children}
                    <div className={styles['mobile-footer']}>
                        <FooterImage />
                    </div>
                </div>
                <div
                    className={classnames(styles['right-content'], {
                        [styles['right-content--with-background']]: Boolean(
                            props.rightPaneBackground
                        ),
                    })}
                >
                    {props.rightPaneBackground ? (
                        <div className={styles['right-pane-background']}>
                            {props.rightPaneBackground}
                        </div>
                    ) : null}
                    <div
                        className={classnames(styles['illustration-panel'], {
                            [styles['illustration-panel--centered']]: props.centerIllustration,
                        })}
                    >
                        {props.illustration}
                    </div>
                    {showDesktopIllustrationFooter ? (
                        <div className={styles['desktop-footer']}>
                            <FooterImage />
                        </div>
                    ) : null}
                </div>
            </div>
        </div>
    );
}
